import { AssetType, FactorAssetInfo } from 'types/factor'
import { isDefined } from './common'

export function storeFactorAssets(hostName: string, factorAssets: FactorAssetInfo[]) {
  if (!isDefined(hostName) || !isDefined(factorAssets)) {
    return
  }

  // Obtain existing data from localStorage
  const existingData = localStorage.getItem('factorAssets')
  let factorAssetsMap: Record<string, FactorAssetInfo[]> = {}

  if (existingData) {
    try {
      factorAssetsMap = JSON.parse(existingData)
    } catch (error) {
      console.error('Error parsing factorAssets from localStorage:', error)
      factorAssetsMap = {}
    }
  }

  // Update or clear the assets for this hostName
  if (factorAssets.length > 0) {
    factorAssetsMap[hostName] = factorAssets
  } else {
    delete factorAssetsMap[hostName]
  }

  // Save the updated structure in localStorage
  localStorage.setItem('factorAssets', JSON.stringify(factorAssetsMap))
}

export function getFactorAssets(hostName: string): FactorAssetInfo[] {
  const storedData = localStorage.getItem('factorAssets')

  if (!storedData) {
    return []
  }

  try {
    const factorAssetsMap: Record<string, FactorAssetInfo[]> = JSON.parse(storedData)

    // If hostName is provided, return only its assets
    if (isDefined(hostName)) {
      return factorAssetsMap[hostName] || []
    }

    // If hostName is not provided, return a empty array
    return []
  } catch (error) {
    console.error('Error parsing factorAssets from localStorage:', error)
    return []
  }
}

export function getSingletonFactorAssetByType(assetType: AssetType, hostName: string) {
  const assets = getFactorAssets(hostName)
  return assets.find((asset) => asset.assetType === assetType)
}
